import React, {useEffect, Fragment, useState, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getUser} from "../../core/actions/UserActions";
import {getAuthOptions} from "@core/actions/AuthOptionActions";
import AuthTab from "../../core/components/tabs/AuthTab";
import {Form} from "react-final-form";
import useAuth from "../../core/hooks/useAuth";
import ResetPasswordPage from "./ResetPasswordPage";
import NightModeToggle from "./NightModeToggle";

// Single URL `/customer/` with `?view=` query for which auth sub-view is
// active. Mirrors the bidding theme's auth shell so brand templates
// can hand off via the same `loginUrl()` / `newOrderUrl()` helpers
// regardless of theme — the underlying SPA reads the view from query
// instead of a per-theme `/customer/reset-password` path.
const isResetView = () => new URLSearchParams(window.location.search).get('view') === 'reset-password';

function Index() {
    const {authorized, registered} = useSelector(state => state.user);
    const dispatch = useDispatch();
    const [showResetPassword, setShowResetPassword] = useState(isResetView);

    useEffect(() => {
        dispatch(getUser());
        dispatch(getAuthOptions());
    }, [])

    useEffect(() => {
        const onPopState = () => {
            setShowResetPassword(isResetView());
        };
        window.addEventListener('popstate', onPopState);
        return () => window.removeEventListener('popstate', onPopState);
    }, []);

    const loginEmailRef = useRef('');

    const navigateTo = (show) => {
        const path = show ? '/customer/?view=reset-password' : '/customer/';
        window.history.pushState(null, '', path);
        document.title = show ? 'Reset Password' : 'Login';
        setShowResetPassword(show);
    };

    const handleForgotPassword = () => {
        const emailInput = document.querySelector('input[name="login.email"]');
        if (emailInput) {
            loginEmailRef.current = emailInput.value;
        }
        navigateTo(true);
    };

    const handleSignIn = () => {
        navigateTo(false);
    };

    const onSubmit = useAuth();

    if (authorized === undefined) {
        return false;
    }

    if (authorized === true) {
        setTimeout(() => {
            window.location.href = registered ? '/account/order/' : '/account/';
        }, 800);
    }

    return <Fragment>
        <style>
            {`
                @media (max-width: 3000px) and (min-width: 992px) {
                    body {
                        background: linear-gradient(to left, rgb(238, 240, 243) 50%, #fff 50%);
                        overflow-x: hidden;
                        height: 100vh;
                    }
                    body.dark {
                        background: linear-gradient(to left, #1e2736 50%, #171d27 50%);
                    }
                    body:before{
                        content: '';
                        background-image: url(/_core/assets/themes/v5/assets/img/form3/lp-bg-img.png);
                        position: absolute;
                        width: 100%;
                        bottom: 0;
                        right: 0;
                        z-index: 1;
                        background-repeat: no-repeat;
                        border-radius: 30px 0 0 0;
                        height: 676px;
                        background-size: cover;
                    }
                    body.dark:before{
                        opacity: 0.15;
                    }
                }
                @media (max-width: 3000px) and (min-width: 1661px){
                    body:before{
                        max-width: 804px;
                        height: 600px;
                    }
                }
                @media (max-width: 1660px) and (min-width: 1391px){
                    body:before{
                        max-width: 660px;
                        height: 600px;
                    }
                }
                @media (max-width: 1390px) and (min-width: 1081px){
                    body:before{
                        max-width: 500px;
                        height: 490px;
                    }
                }
                @media (max-width: 1080px) and (min-width: 992px){
                    body:before{
                        max-width: 400px;
                        height: 380px;
                    }
                }
                @media (max-width: 991px) {
                    body.dark {
                        background: #171d27;
                    }
                }
            `}
        </style>
        <header className="header-of">
            <div className="container_v3">
                <a target="_blank" href="/" className="header__logo">
                    <img src="/account/img/logo.svg" alt="logo" className="logo-link"/>
                </a>
            </div>
        </header>
        <div className="lp-app_v3-side-bg">
            <NightModeToggle/>
        </div>
        <div className="login__page">
            <div className="container_v3">
                {showResetPassword ? (
                    <ResetPasswordPage
                        initialEmail={loginEmailRef.current}
                        onSignIn={handleSignIn}
                    />
                ) : (
                    <Fragment>
                        <div className="auth-form auth-form__auth">
                            <div className="auth-form__inner">
                                <Form onSubmit={onSubmit}>
                                    {({handleSubmit, submitting}) => (
                                        <form onSubmit={handleSubmit} id={'login-form'}>
                                            <AuthTab
                                                onForgotPassword={handleForgotPassword}
                                                registerButton={(
                                                    <div className="form-btn_v3">
                                                        <button
                                                            className="btn_v3 btn_v3-md btn_v3-primary btn_v3-with-icon"
                                                            disabled={submitting}>
                                                            {submitting ? 'Creating...' : 'Create account'}
                                                            <span className="btn_v3__icon">
                                                                <img
                                                                    src="/_core/assets/themes/v5/assets/img/form3/arrow-long-right.svg"
                                                                    alt=""/>
                                                            </span>
                                                        </button>
                                                    </div>
                                                )}
                                                loginButton={(
                                                    <div className="form-btn_v3">
                                                        <button
                                                            className="btn_v3 btn_v3-md btn_v3-primary btn_v3-with-icon"
                                                            disabled={submitting}>
                                                            {submitting ? 'Signing in...' : 'Sign In'}
                                                            <span className="btn_v3__icon">
                                                                <img
                                                                    src="/_core/assets/themes/v5/assets/img/form3/arrow-long-right.svg"
                                                                    alt=""/>
                                                            </span>
                                                        </button>
                                                    </div>
                                                )}
                                            />
                                        </form>
                                    )}
                                </Form>
                            </div>
                        </div>
                    </Fragment>
                )}
            </div>
        </div>
    </Fragment>
}

export default Index
